(function () {
  'use strict';

  document.querySelectorAll('.tov-how-it-works-section').forEach(function (sectionEl) {
    var sid    = sectionEl.dataset.sectionId || '';
    var header = document.getElementById('workflow-header-' + sid);
    var cards  = sectionEl.querySelectorAll('.workflow-card');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el    = entry.target;
          var delay = parseInt(el.dataset.delay || '0', 10);
          setTimeout(function () { el.classList.add('visible'); }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    if (header) observer.observe(header);
    cards.forEach(function (card) { observer.observe(card); });
  });

}());
